module.exports = __webpack_public_path__ + "img/11.390a7b4f.jpg";